export enum PlanType {
  Monthly = 'monthly',
  Annual = 'annual',
}
